export const Images = {
  logo: require('./logo.png'),
  smallLogo: require('./small-logo.png'),
  footerLogo: require('./footer/footer-logo.png'),
  profileImage: require('./profile/dummy-user-img.jpg'),
  carImage: require('../images/card/cart-image.jpg'),
  successIcon: require('./success-icon.png'),
  mapImage: require('./map-image.png'),
  sponsorImage: require('./sponsor-logo.png'),
  nodataImage: require('./no-data-image.jpg'),
  error404: require('./404-error.png'),
}
